import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import ALoader from '@/components/atoms/ALoader.vue'
	import MNoData from '@/components/molecules/MNoData.vue'
	import MFilters from '@/components/molecules/MFilters.vue'
	import AgDatatable from '@/components/datatable/AgDatatable.vue'
	import DefaultCellRenderer from '@/components/datatable/cellRenderers/DefaultCellRenderer.vue'

	import type { ObjectContext } from '@/global'
	import { ComputedRef } from 'vue'

	import { reactive, computed, watch } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		tabSelected: { type: String, default: '', required: true },
		modelValue: { type: [Array, Number], default: null },
		multiple: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false }
	},
  emits: ['update:modelValue', 'input', 'change', 'blur', 'clear', 'enter', 'deleteKey'],
  setup(__props, { emit: $emit }) {

const $props = __props

	
	

	const { $t, $store, loading, isNew } = useGeneral()

	const state = reactive({
		loading: false,
		filtersDrawer: false,
		selection: null,
		items: []
	})

	const selectionText = computed(() =>
		$t($props.multiple ? 'General_entity_selection_multiple_html' : 'General_entity_selection_simple_html', null, { element: $t(tabSelectedElement.value) })
	)
	const selectedText = computed(() =>
		$t($props.multiple ? 'General_entity_selected_multiple_html' : 'General_entity_selected_simple_html', null, { element: $t(tabSelectedElement.value) })
	)

	const tabSelectedElement: ComputedRef<string> = computed(() => $store.getters['roles/GET_TAB_ELEMENTS'][$props.tabSelected])
	const itemIdKey = computed(() => $store.getters['GET_ITEM_ID_KEY'][$props.tabSelected] || '')

	function onUpdateValue() {
		$emit('update:modelValue', state.selection)
	}

	const rowSelection = computed(() => ($props.multiple ? 'multiple' : 'single'))

	// @ts-ignore
	const columns: Array<string> = computed(() => {
		const items = JSON.parse(JSON.stringify($store.getters['dictionary/GET_API_COLUMNS'][$props.tabSelected] || []))
		if (items.length && !$props.disabled) items.unshift('selection')
		const avoidColumns = ['warehouse_crops', 'created_at']
		return items.filter((e: string) => !avoidColumns.includes(e))
	})
	// @ts-ignore
	const headers: Array<ObjectContext> = computed(() => {
		// @ts-ignore
		return columns.value.map((key: string) => {
			return {
				mainTable: true,
				headerName: key !== 'selection' ? key : '',
				field: key,
				resizable: key === 'selection' ? false : true,
				width: key === 'selection' ? 15 : '',
				sortable: false,
				editable: false,
				checkboxSelection: key === 'selection',
				cellRenderer: key !== 'selection' ? DefaultCellRenderer : ''
			}
		})
	})

	function onToggleFiltersDrawer() {
		state.filtersDrawer = !state.filtersDrawer
	}

	async function init(filters?: ObjectContext) {
		state.loading = true
		const body = {
			_is_local_items: true,
			tabSelected: $props.tabSelected,
			// @ts-ignore
			columns: columns.value
		}
		if (!isNew.value) {
			const value = $props.modelValue
			// @ts-ignore
			body.query = {}
			// @ts-ignore
			body.query[itemIdKey.value] = {
				in: Array.isArray(value) ? value : [value]
			}
			// @ts-ignore
		} else if (filters) body.filters = filters
		try {
			const items = await $store.dispatch('getData', body)
			state.items = JSON.parse(JSON.stringify(items))
		} catch (error) {
			$store.dispatch('alert/SET_ALERT', { action: 'get', error })
		} finally {
			state.loading = false
		}
	}
	init()

	watch(
		() => $props.modelValue,
		val => {
			// @ts-ignore
			state.selection = val
			if (!isNew.value) init()
		}
	)

	function onChangeFilters(filters: ObjectContext) {
		init(filters)
	}

	function onSelectionChanged(selection: Array<ObjectContext>) {
		const selectionIds = selection.map(e => e[itemIdKey.value])
		const selected = $props.multiple ? selectionIds : selectionIds.length > 0 ? selectionIds[0] : null
		// @ts-ignore
		state.selection = selected
		onUpdateValue()
	}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_unref(state).loading)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "fill-height"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            align: "center",
            justify: "enter",
            class: "fill-height"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(ALoader, {
                    width: 5,
                    size: 150
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              (_unref(isNew))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    innerHTML: _unref(selectionText)
                  }, null, 8, _hoisted_1))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    innerHTML: _unref(selectedText)
                  }, null, 8, _hoisted_2))
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "text-right"
          }, {
            default: _withCtx(() => [
              (!$props.disabled)
                ? (_openBlock(), _createBlock(MFilters, {
                    key: 0,
                    modelValue: _unref(state).filtersDrawer,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).filtersDrawer) = $event)),
                    "tab-selected": "warehouses",
                    "save-filters": false,
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (onChangeFilters($event)))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              (!_unref(state).items.length)
                ? (_openBlock(), _createBlock(MNoData, {
                    key: 0,
                    "tab-selected": $props.tabSelected,
                    filters: "",
                    "emit-click": "",
                    "main-table": "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (onToggleFiltersDrawer()))
                  }, null, 8, ["tab-selected"]))
                : (_unref(headers).length)
                  ? (_openBlock(), _createBlock(AgDatatable, {
                      key: 1,
                      headers: _unref(headers),
                      items: _unref(state).items,
                      "row-selection": _unref(rowSelection),
                      "auto-height": "",
                      onSelectionChanged: _cache[3] || (_cache[3] = ($event: any) => (onSelectionChanged($event)))
                    }, null, 8, ["headers", "items", "row-selection"]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}
}

})